<template>
	<div class="after-sale-page">

		<!-- 面包屑导航 -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">{{$t('shopSuss.t1')}}</span>
				<span class="crumb-home">{{$t('userPageL.txt5')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-home">{{$t('shopOrder.t15')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">{{$t('myShopOrder.t29')}}</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 主卡片 (1596×715px) ===== -->
		<div class="main-card animate__animated  ">

			<!-- ===== 售后商品 ===== -->
			<div class="section-block">
				<div class="section-title-row">
					<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30869_9563/29.svg')"></el-image>
					<h3 class="title-text">{{$t('myShopOrder.t43')}}</h3>
				</div>

				<!-- 订单商品卡片 -->
				<div class="order-item-card">
					<div class="item-header-row">
						<div class="shop-tag1" v-if="orderGoods.channelType==1">
							<span class="tag-text">{{$t('shopCar.t4')}}</span>
						</div>
						<div class="shop-tag" v-if="orderGoods.channelType==2">
							<span class="tag-text">1688</span>
						</div>
						<div class="shop-tag2" v-if="orderGoods.channelType==3">
							<span class="tag-text">{{$t('shopIndex.t16')}}</span>
						</div>
						<div class="shop-tag" v-if="orderGoods.channelType==4">
							<span class="tag-text">{{$t('shopIndex.t15')}}</span>
						</div>
						<el-image class="shop-avatar" :src="require('@/static/CodeBuddyAssets/30869_9563/27.svg')"></el-image>
						<span class="shop-name">{{orderGoods.merchantName}}</span>
					</div>
					<div class="item-body-row">
						<el-image class="item-img" :src="orderGoods.picUrl" :preview-src-list="[orderGoods.picUrl]" fit="cover"></el-image>
						<div class="item-info" v-if="orderGoods">
							<p class="item-name">{{orderGoods.goodsName}}</p>
							<p class="item-spec">{{orderGoods.specifications.join(' ')}}</p>
						</div>
						<div class="rbox">
							<div class="item-qty">{{$t('shopOrder.t19')}}{{orderGoods.number}}</div>
							<div class="item-refund-area f-ct">
								<span class="refund-label">{{$t('myShopOrder.t44')}}</span>
								<span class="refund-price">
									<span class="price-symbol">￥</span>
									<span class="price-number">{{defaultReturnAmount}}</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ===== 售后信息 ===== -->
			<div class="section-block info-section">
				<div class="section-title-row">
					<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30869_9563/30.svg')"></el-image>
					<h3 class="title-text">{{$t('myShopOrder.t45')}}</h3>
				</div>

				<div class="info-flex-row">
					<!-- 售后类型 -->
					<div class="info-field">
						<div class="field-label">
							<span class="required-star">*</span>
							<span class="label-text">{{$t('myShopOrder.t46')}}</span>
						</div>
						<div class="field-select">
							<el-select v-model="orderRightTypeIdx" @change="rightTypeF" :placeholder="$t('shopOrder.t18')" class="form-select">
								<el-option v-for="item in orderRightType" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
							</el-select>
						</div>
					</div>

					<!-- 申请原因 -->
					<div class="info-field field-right" v-if="orderRightReason.length">
						<div class="field-label">
							<span class="required-star">*</span>
							<span class="label-text">{{$t('myShopOrder.t47')}}</span>
						</div>
						<div class="field-select">
							<el-select v-model="orderRightReasonIdx" :placeholder="$t('shopOrder.t18')" class="form-select">
								<el-option v-for="item in orderRightReason" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>

			<!-- ===== 补充描述和凭证 ===== -->
			<div class="section-block evidence-section">
				<div class="section-title-row">
					<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30869_9563/30.svg')"></el-image>
					<h3 class="title-text">{{$t('myShopOrder.t48')}}</h3>
				</div>

				<div class="evidence-textarea">
					<el-input
						class="desc-input"
						v-model="content"
						type="textarea"
						:rows="5"
						:placeholder="$t('myShopOrder.t49')">
					</el-input>
					
					<!-- 上传照片 -->
					<div class="upload-area">
						<el-upload
							class="upload-container"
							ref="cancelUpload"
							:accept="'.jpg,.jpeg,.png'"
							:action="uplink"
							list-type="picture-card"
							:on-success="uplinkportrait"
							:on-remove="handleRemove">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
				</div>
				
			</div>

			<!-- 提交按钮 -->
			<div class="submit-area">
				<div class="submit-btn" @click="goorderapply">{{$t('myOrderPay.t19')}}</div>
			</div>

		</div>
	</div>
</template>

<script>
import {
	returnTypeAll,
	orderapplyInfo,
	orderapply,
	configbase,
} from "/src/api/api.js"
export default {
	name: 'MyShopOrderReturn',
	data() {
		return {
			peizhi:'',
			pzMsgAll:'',
			orderStatus:0,
			id:0,
			defaultReturnAmount:'',
			orderGoods:'',
			orderRightType:[],
			orderRightTypeIdx:'',
			orderRightReason:[],
			orderRightReasonIdx:'',
			// 弹出框
			hbSel1:false,
			hbSel2:false,
			// 表单
			cancelGallery:[],
			content:'',
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		if(this.$route.query.id){
			this.orderStatus = this.$route.query.orderStatus*1
		}
		this.configbase()
		this.getorderrights()
	},
	methods: {
		// 提交
		async goorderapply(){
			if(!this.orderRightTypeIdx){
				this.Tips(this.$t('myShopOrder.t50'))
				return
			}
			if(this.orderRightReason.length){
				if(!this.orderRightReasonIdx){
					this.Tips(this.$t('myShopOrder.t51'))
					return
				}
			}
			var data = {
				gallery:this.cancelGallery,
				orderGoodsId:this.id,
				returnAmount:this.defaultReturnAmount,
				rightNote:this.content,
				rightTypeId:this.orderRightTypeIdx,
			}
			if(this.orderRightReason.length){
				data.rightReasonId = this.orderRightReasonIdx
			}
			const res = await orderapply(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.back()
			}else{this.Tips(res.msg,'error')}
		},
		// 基本配置
		async configbase(){
			const res = await configbase({})
			if(res.code==200){
				this.peizhi = res.data
				this.GetconfigbaseDictData()
			}else{this.Tips(res.msg,'error')}
		},
		// 字典
		async GetconfigbaseDictData(){
			const res = await returnTypeAll({})
			if(res.code==200){
				this.orderRightType = res.data.orderRightType
				this.pzMsgAll = res.data
				if(this.orderStatus==1||this.orderStatus==2){
					this.orderRightType = [res.data.orderRightType[0]]
					if(this.peizhi.orderSystemRefundCauseOpen*1){
						this.orderRightReason = res.data.rightRefundCause
					}
				}else{
					this.orderRightType = res.data.orderRightType
					if(this.peizhi.orderSystemCauseOpen*1){
						this.orderRightReason = res.data.orderRightReason
					}
				}
				// this.orderRightReason = res.data.orderRightReason
			}else{this.Tips(res.msg,'error')}
		},
		rightTypeF(e){
			console.log(e)
			// 清除
			this.orderRightReason = []
			this.orderRightReasonIdx = ''
			if(e==2){
				if(this.peizhi.orderSystemCauseOpen*1){
					this.orderRightReason = this.pzMsgAll.orderRightReason
				}
			}else{
				if(this.peizhi.orderSystemRefundCauseOpen*1){
					this.orderRightReason = this.pzMsgAll.rightRefundCause
				}
			}
		},
		// 售后详情
		async getorderrights(){
			const res = await orderapplyInfo({id:this.id})
			if(res.code==200){
				this.defaultReturnAmount = res.data.defaultReturnAmount
				this.orderGoods = res.data.orderGoods
			}else{this.Tips(res.msg,'error')}
		},
		// 图片上传
		uplinkportrait(response,file,fileList) {
			if(response.code==200){
				this.cancelGallery.push(response.data.url)
			}else{
				this.Tips(response.msg,'error');
				let index = 0;
				for(const i in fileList){
					if(fileList[i]==file){
						index=i;
						break;
					}
				}
				fileList.splice(index,1);
			}
		},
		// 删除图片
		handleRemove(file, fileList) {
			var cancelGallery = []
			fileList.forEach((item)=>{
				cancelGallery.push(item.response.data.url)
			})
			this.cancelGallery = cancelGallery
		},
	},
}
</script>

<style lang="scss" scoped>
.after-sale-page {
	width: 100%;
	box-sizing: border-box;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* ===================================================================
   主卡片 (1596×715px)
   =================================================================== */
.main-card {
	width: 1596px;
	background: #fff;
	border-radius: 12px;
	padding: 24px 24px 32px;
	box-sizing: border-box;
	position: relative;
}

/* ---- 通用区块 ---- */
.section-block {
	margin-bottom: 24px;
}
.section-title-row {
	display: flex;
	align-items: center;
	height: 28px;
	margin-bottom: 16px;
}
.title-icon {
	width: 8px;
	height: 18px;
	flex-shrink: 0;
}
.title-text {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	margin-left: 4px;
}

/* ===================================================================
   订单商品卡片 (868×155px)
   =================================================================== */
.order-item-card {
	width: 868px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 6px;
	box-sizing: border-box;
}

.item-header-row {
	display: flex;
	align-items: center;
	height: 39px;
	background: #f8f8f8;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	padding: 0 16px;
	box-sizing: border-box;
}
.shop-tag {
	// width: 31px;
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #FFE9E9;
	border: 1px solid #FC3C3C;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #FC3C3C;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}
.shop-tag1 {
	// width: 31px;
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #E9F5FF;
	border: 1px solid #0096FF;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #0096FF;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}
.shop-tag2 {
	// width: 31px;
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #FFF5E9;
	border: 1px solid #FF7120;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #FF7120;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}
.tag-bg {
	width: 31px;
	height: 16px;
	position: absolute;
	left: 0;
	top: 0;
}
.tag-text {
	font-size: 10px;
	color: #FC3C3C;
	font-weight: 400;
	z-index: 1;
	position: relative;
}
.shop-avatar {
	width: 18px;
	height: 18px;
	margin-left: 6px;
	flex-shrink: 0;
}
.shop-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}

.item-body-row {
	display: flex;
	align-items: flex-start;
	padding: 16px 24px;
	box-sizing: border-box;
}
.item-img {
	width: 68px;
	height: 68px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.item-info {
	margin-left: 12px;
	flex: 1;
}
.item-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin: 0 0 8px;
	line-height: 1.4;
}
.item-spec {
	font-size: 14px;
	color: #7A7A7A;
	font-weight: 400;
	margin: 0;
}
.item-qty {
	font-size: 14px;
	font-weight: 500;
	color: #666;
	flex-shrink: 0;
	margin-right: 40px;
	margin-top: 2px;
}
.item-refund-area {
	flex-shrink: 0;
	text-align: right;
	margin-top: 2px;
}
.refund-label {
	font-size: 14px;
	color: #666;
	font-weight: 400;
	display: block;
	padding-right: 4px;
}
.refund-price {
	white-space: nowrap;
}
.price-symbol {
	font-size: 12px;
	font-weight: 500;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}
.price-number {
	font-size: 20px;
	font-weight: 600;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}

/* ===================================================================
   售后信息
   =================================================================== */
.info-section {
	margin-top: 10px;
}
.info-flex-row {
	display: flex;
	align-items: flex-start;
}
.info-field {
	width: 414px;
}
.field-right {
	margin-left: 20px;
}
.field-label {
	height: 22px;
	margin-bottom: 12px;
	display: flex;
	align-items: center;
}
.required-star {
	font-size: 16px;
	color: #FC3C3C;
	font-weight: 400;
	margin-right: 4px;
}
.label-text {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.field-select {
	width: 414px;
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	display: flex;
	align-items: center;
	padding: 0 16px;
	box-sizing: border-box;
	cursor: pointer;
	transition: border-color 0.3s;
	padding-right: 6px;
	&:hover {
		border-color: #0096FF;
	}
	.el-select{
		width: 100%;
	}
	::v-deep .el-input__inner{
		padding: 0;
		border: 0;
	}
}
.select-text {
	font-size: 16px;
	color: #333;
	font-weight: 400;
	flex: 1;
}
.select-arrow {
	width: 14px;
	height: 14px;
	flex-shrink: 0;
}

/* ===================================================================
   补充描述和凭证
   =================================================================== */
.evidence-section {
	margin-top: 40px;
}
.evidence-textarea {
	width: 860px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding-bottom: 16px;
}
.evidence-textarea ::v-deep .el-textarea__inner {
	width: 860px;
	min-height: 210px;
	background: transparent;
	border: 1px solid #FAFAFA;
	font-size: 14px;
	color: #333;
	padding: 20px;
	box-sizing: border-box;
	resize: none;
	font-family: 'PingFang SC', sans-serif;
	line-height: 1.6;
}
.evidence-textarea ::v-deep .el-textarea__inner::placeholder {
	color: #999;
}

.upload-area {
	margin-top: 16px;
	display: flex;
	padding-left: 16px;
}
.upload-box {
	width: 70px;
	height: 69px;
	border: 1px solid #CBCBCB;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: border-color 0.3s;
	&:hover {
		border-color: #0096FF;
	}
}
.upload-icon {
	width: 18px;
	height: 18px;
}
.upload-text {
	font-size: 12px;
	color: #CBCBCB;
	font-weight: 400;
	margin-top: 4px;
}

/* ===================================================================
   提交按钮
   =================================================================== */
.submit-area {
	display: flex;
	justify-content: flex-end;
	margin-top: 52px;
}
.submit-btn {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border-radius: 10px;
	text-align: center;
	line-height: 60px;
	font-size: 18px;
	font-weight: 500;
	color: #fff;
	cursor: pointer;
	transition: background 0.3s;
	&:hover {
		background: #33ABFF;
	}
}
.rbox{
	.item-qty{
		text-align: right;
		margin: 0;
		margin-bottom: 12px;
	}
}
</style>
